module.exports = __webpack_public_path__ + "static/media/Nad_mlynem.17967345.md";